import { mergeObjectTypes } from '../cacheHelpers';

const CargoSummary = {
  merge: mergeObjectTypes
};

export default CargoSummary;
